import script from "./DpSpacesHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./DpSpacesHeader.vue?vue&type=script&setup=true&lang=ts"

import "./DpSpacesHeader.vue?vue&type=style&index=0&id=ccd1cff2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccd1cff2"]])

export default __exports__